import React from "react";
import { Button, Col, Modal, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { SmileOutlined, FrownOutlined } from "@ant-design/icons";
import TermAccept from "@components/TermAccept";
import useStateTermAccept from "@components/TermAccept/hook";

const { Title, Text } = Typography;

const BitelModalConfirm = ({ message, title, visible, handleOk, handleCancel, isCancelAction, isShowAcceptTerm = true }) => {
  const { t } = useTranslation();
  const { acceptTerms, setAcceptTerms, showError, setShowError } = useStateTermAccept();

  const handleClickOk = () => {
    if (!isShowAcceptTerm) {
      handleOk();
      return;
    }

    setShowError(!acceptTerms);
    if (acceptTerms) {
      handleOk();
    }
  }
  return (
    <Modal
      className="page-modal"
      centered
      maskClosable={false}
      visible={visible}
      width={"sm"}
      onCancel={handleCancel}
      footer={[
        <Row justify="center" key={1}>
          <Col span={18}>
            <Button
              className="page-modal-button"
              onClick={handleClickOk}
            >
              {t("modal.ok")}
            </Button>
          </Col>
          <Text className="page-modal-info">{t("modal.message_info")}</Text>
          <Col span={18}>
            <Button
              className="page-modal-cancel"
              onClick={handleCancel}
            >
              {t("modal.cancel")}
            </Button>
          </Col>
          <Col style={{ marginTop: "30px" }}>
            {!isCancelAction && isShowAcceptTerm && <TermAccept acceptTerms={acceptTerms} setAcceptTerms={setAcceptTerms} showError={showError} />}
          </Col>
        </Row>,
      ]}
    >
      <Row justify="center">
        <Col md={18}>
          {isCancelAction ? <FrownOutlined className="page-modal-icon" /> : <SmileOutlined className="page-modal-icon" />}
          <Title level={3} className="page-modal-title page-modal-title-confirm">
            {title}
          </Title>
          <Text className="page-modal-content">
            {message}
          </Text>
        </Col>
      </Row>
    </Modal>
  );
};

export default BitelModalConfirm;
